module.exports = __webpack_public_path__ + "static/img/case_img02.e3adf09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jieju/case_img02.png
// module id = KCLn
// module chunks = 1